import styled from 'styled-components';
import parse from 'html-react-parser';
interface CustomTextStyleType {
  className?: string;
  text?: string | number;
  gap?: string;
  color?: string;
  justifyContent?: string;
  direction?: string;
  alignItems?: string;
  width?: string;
  fontSize?: string;
  lineHeight?: string;
  fontWeight?: string;
  mdDirection?: string;
  mdMarginBottom?: string;
  mdMarginTop?: string;
  mdGap?: string;
  mdFontSize?: string;
  mdLineHeight?: string;
  mdFontWeight?: string;
  mdHeight?: string;
  maxWidth?: string;
  mdMaxWidth?: string;
  textAlign?: string;
  height?: string;
  display?: string;
  marginTop?: string;
  marginBottom?: string;
  marginLeft?: string;
  marginRight?: string;
  cursor?: string;
  onClick?: () => void;
  letterSpacing?: string;
  bgColor?: string;
  borderRadius?: string;
  textDecoration?: string;
  border?: string;
  borderLeft?: string;
  borderRight?: string;
  borderTop?: string;
  borderBottom?: string;
  borderTopLeftRadius?: string;
  borderTopRightRadius?: string;
  borderBottomLeftRadius?: string;
  borderBottomRightRadius?: string;
  paddingTop?: string;
  paddingRight?: string;
  paddingBottom?: string;
  paddingLeft?: string;
  mdBorderRight?: string;
  mdAlignItems?: string;
  fontFamily?: string;
}


export const CustomTextStyle = styled.div<CustomTextStyleType>`
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: ${(props) => props.fontFamily || 'Open Sans'};
  max-width: ${(props) => props.maxWidth || '100%'};
  width: ${(props) => props.width};
  align-items: ${(props) => props.alignItems || 'center'};
  display: ${(props) => props.display || 'flex'};
  justify-content: ${(props) => props.justifyContent || 'start'};
  color: ${(props) => props.color || 'black'};
  flex-direction: ${(props) => props.direction || 'row'};
  gap: ${(props) => props.gap || '0px'};
  margin-bottom: ${(props) => props.marginBottom || '0px'};
  margin-top: ${(props) => props.marginTop || '0px'};
  font-weight: ${(props) => props.fontWeight || '700'};
  font-size: ${(props) => props.fontSize || '28px'};
  line-height: ${(props) => props.lineHeight || '140%'};
  text-align: ${(props) => props.textAlign || 'start'};
  height: ${(props) => props.height || ''};
  margin-top: ${(props) => props.marginTop || '0px'};
  margin-bottom: ${(props) => props.marginBottom || '0px'};
  margin-left: ${(props) => props.marginLeft || '0px'};
  margin-right: ${(props) => props.marginRight || '0px'};
  cursor: ${(props) => props.cursor};
  letter-spacing: ${(props) => props.letterSpacing || '0'};
  background: ${(props) => props.bgColor};
  border-right: ${(props) => props.borderRight};
  border-left: ${(props) => props.borderLeft};
  border-top: ${(props) => props.borderTop};
  border-bottom: ${(props) => props.borderBottom};
  border-top-left-radius: ${(props) => props.borderRadius ? props.borderRadius : props.borderTopLeftRadius};
  border-bottom-left-radius: ${(props) => props.borderRadius ? props.borderRadius : props.borderBottomLeftRadius};
  border-top-right-radius: ${(props) => props.borderRadius ? props.borderRadius : props.borderTopRightRadius};
  border-bottom-right-radius: ${(props) => props.borderRadius ? props.borderRadius : props.borderBottomRightRadius};
  border: ${(props) => props.border};
  text-decoration: ${(props) => props.textDecoration};
  padding-top: ${(props) => props.paddingTop};
  padding-bottom: ${(props) => props.paddingBottom};
  padding-right: ${(props) => props.paddingRight};
  padding-left: ${(props) => props.paddingLeft};
  strong{
    color: #f96969;
    font-weight: 600;
    
  }
  a{
    text-decoration: underline;
    font-weight: 500;
  }
    &.three-dots{
      white-space: nowrap;
      overflow: hidden!important;
      text-overflow: ellipsis;
    } 
    &.word-wrap{
    word-wrap: break-word;
  }

  @media screen and (max-width: 768px) {
    max-width: ${(props) => props.mdMaxWidth || '100%'};
    margin-bottom: ${(props) => props.mdMarginBottom || props.marginBottom};
    margin-top: ${(props) => props.mdMarginTop || props.marginTop};
    gap: ${(props) => props.mdGap || props.gap};
    font-weight: ${(props) => props.mdFontWeight || props.fontWeight};
    font-size:${(props) => props.mdFontSize || '18px'};
    line-height: ${(props) => props.mdLineHeight || '26px'};
    height: ${(props) => props.mdHeight};
    border-right: ${(props) => props.mdBorderRight};
    align-items: ${(props) => props.mdAlignItems};
  }
`
const CustomText = ({
  text,
  width,
  color,
  direction,
  justifyContent,
  alignItems,
  gap,
  marginBottom,
  marginTop,
  fontWeight,
  fontSize,
  lineHeight,
  mdMarginBottom,
  mdMarginTop,
  mdGap,
  mdFontWeight,
  mdFontSize,
  mdLineHeight,
  className,
  textAlign,
  height,
  mdHeight,
  maxWidth,
  mdMaxWidth,
  display,
  cursor,
  onClick,
  letterSpacing,
  bgColor,
  borderRadius,
  textDecoration,
  border,
  borderBottomLeftRadius,
  borderBottomRightRadius,
  borderTopLeftRadius,
  borderTopRightRadius,
  paddingTop,
  paddingLeft,
  paddingRight,
  paddingBottom,
  mdBorderRight,
  mdAlignItems,
  fontFamily,
  borderTop,
  borderLeft,
  borderBottom,
  borderRight
}: CustomTextStyleType) => {
  let _text = typeof (text) === 'number' ? text.toString() : text;
  // console.log(_text, typeof (_text))
  return (
    <CustomTextStyle
      text={text}
      width={width}
      color={color}
      direction={direction}
      justifyContent={justifyContent}
      alignItems={alignItems}
      gap={gap}
      marginBottom={marginBottom}
      marginTop={marginTop}
      fontWeight={fontWeight}
      fontSize={fontSize}
      lineHeight={lineHeight}
      mdMarginBottom={mdMarginBottom}
      mdMarginTop={mdMarginTop}
      mdGap={mdGap}
      mdFontWeight={mdFontWeight}
      mdFontSize={mdFontSize}
      mdLineHeight={mdLineHeight}
      className={className}
      textAlign={textAlign}
      height={height}
      mdHeight={mdHeight}
      maxWidth={maxWidth}
      mdMaxWidth={mdMaxWidth}
      display={display}
      cursor={cursor}
      onClick={onClick}
      letterSpacing={letterSpacing}
      bgColor={bgColor}
      borderRadius={borderRadius}
      textDecoration={textDecoration}
      border={border}
      borderBottomLeftRadius={borderBottomLeftRadius}
      borderTopLeftRadius={borderTopLeftRadius}
      borderTopRightRadius={borderTopRightRadius}
      borderBottomRightRadius={borderBottomRightRadius}
      paddingTop={paddingTop}
      paddingLeft={paddingLeft}
      paddingBottom={paddingBottom}
      paddingRight={paddingRight}
      mdAlignItems={mdAlignItems}
      mdBorderRight={mdBorderRight}
      fontFamily={fontFamily}
      borderTop={borderTop}
      borderBottom={borderBottom}
      borderRight={borderRight}
      borderLeft={borderLeft}
    >
      {parse(_text)}
    </CustomTextStyle>
  )
}

export default CustomText;